import React from "react";
import { useHistory } from "react-router-dom";
import logo from "../../assets/DFLogoLarge.png";
import styles from "./InvalidRoute.module.css";

const InvalidRoute = () => {
  const history = useHistory();
  const returnToHome = () => {
    history.push("/");
  };
  return (
    <main className={styles.wrapper}>
      <img src={logo} alt="Digital Factory" />
      <h1>Page does not exist</h1>
      <span
        tabIndex={0}
        role="link"
        onClick={returnToHome}
        onKeyDown={(e) => (e.key === "Enter" ? returnToHome() : undefined)}
      >
        Back to home
      </span>
    </main>
  );
};

export default InvalidRoute;
